<template>
  <section class="add-tests-view">
    <div class="select-test-panel pl-20 coriell-test-block">
      <div class="coriell-test-profiles">
        <h4 class="title">Select Panels</h4>
        <el-select v-model="selectedUrineCulturePanels" multiple placeholder="Select" @change="handleUrineCultureTests"
          @remove-tag="handleRemovedTests" value-key="group_code">
          <el-option v-for="(item, index) in urineCulturePanels" :key="index" :label="item.is_customised ? item.group_title + ' microgen' : item.group_title" :value="item">
          </el-option>
        </el-select>
      </div>
    </div>

    <ul class="add-tests-selection">
      <li class="each-test" v-for="(category, index) of getCaseCategoryData('URINE_CULTURE')" :key="index">
        <el-collapse v-model="activeNameCollapse" accordion>
          <el-collapse-item :name="index">
            <template #title>{{ category.panel_title }}</template>
            <el-checkbox class="test-category" disabled :model-value="isCheckAll(category.case_type_code, category.panel_id)
              " @change="
                checkAll(
                  $event,
                  category.case_type_code,
                  category.panel_id,
                  category.group_id
                )
                ">All</el-checkbox>
            <el-checkbox-group v-model="testsData">
              <div v-for="(item, index) of getCategoryWiseTestsData(
                category.case_type_code,
                category.panel_id
              )" :key="index">
                <div class="each-check-box">
                  <el-checkbox disabled :label="item._id" :value="item">{{
                    item.test_name
                  }}</el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </el-collapse-item>
        </el-collapse>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import AppHelper from "@/mixins/AppHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";

export default {
  props: ["panelTestsData", "searchString"],
  mixins: [AppHelper, UserPermissionsHelper],
  data() {
    return {
      activeNameCollapse: "",
      urineCulturePanels: [],
      selectedUrineCulturePanels: [],
      panelsTestsData: {
        selectedTestIds: [],
        selectedCoriellPanels: [],
        selectedCategories: [],
        selectedGroup: []
      },
      selectedCategoriesWithTests: [],
    };
  },
  computed: {
    ...mapGetters("labTests", [
      "getNewLabGroupWiseTests",
      "getNewLabGroupWiseTestsData",
    ]),
    testsData() {
      if (
        this.panelsTestsData &&
        this.panelsTestsData.selectedTestIds &&
        this.panelsTestsData.selectedTestIds.length
      ) {
        return JSON.parse(JSON.stringify(this.panelsTestsData.selectedTestIds));
      }
      return [];
    },
  },
  methods: {
    getCategoryWiseTestsData(caseType, category) {
      let data = [];
      if (this.searchString) {
        data = this.getNewLabGroupWiseTestsData.filter(
          (el) =>
            el.case_type_code === caseType &&
            el.panel_id === category &&
            (el.test_name.toLowerCase().includes(this.searchString.toLowerCase()) ||
              el.panel_title
                .toLowerCase()
                .includes(this.searchString.toLowerCase()))
        );
      } else {
        data = this.getNewLabGroupWiseTestsData.filter(
          (el) =>
            el.case_type_code === caseType && el.panel_id === category
        );
      }

      const uniqueData = data.filter(
        (test, index, self) =>
          index === self.findIndex((t) => t._id === test._id)
      );

      return this.sortByKey(uniqueData, "test_name");
    },
    getCaseCategoryData(caseType) {
      const data = this.getNewLabGroupWiseTestsData.filter(
        (el) =>
          el.case_type_code === caseType &&
          (!this.searchString ||
            el.test_name.toLowerCase().includes(this.searchString.toLowerCase()) ||
            el.panel_title.toLowerCase().includes(this.searchString.toLowerCase()))
      );

      let flags = [],
        output = [],
        outputWithFullDetails = [],
        l = data.length,
        i;
      for (i = 0; i < l; i++) {
        if (flags[data[i].panel_code]) continue;
        flags[data[i].panel_code] = true;
        output.push(data[i].panel_code);
        outputWithFullDetails.push(data[i]);
      }
      return outputWithFullDetails;
    },
    checkAll(data, caseType, panelId, groupId) {
      if (data) {
        this.panelsTestsData.selectedCategories.push({
          panel_id: panelId,
          case_type_code: caseType,
          all_tests: true,
          group_id: groupId,
          test_ids: this.getNewLabGroupWiseTestsData
            .filter((e) => e.panel_id == panelId)
            .map((e) => e._id),
        });

        this.selectedCategoriesWithTests = [
          ...this.selectedCategoriesWithTests,
          ...this.getNewLabGroupWiseTestsData
            .filter((e) => e.panel_id == panelId)
            .map((e) => e.label_value),
        ];
      } else {
        let index = this.panelsTestsData.selectedCategories.findIndex(
          (e) => e.panel_id == panelId && e.case_type_code == caseType
        );
        if (index > -1) {
          let panelId = this.panelsTestsData.selectedCategories[index].panel_id;
          let testIds = this.getNewLabGroupWiseTestsData
            .filter((e) => e.panel_id == panelId)
            .map((e) => e.label_value);
          this.selectedCategoriesWithTests =
            this.selectedCategoriesWithTests.filter(
              (e) => !testIds.includes(e)
            );
          this.panelsTestsData.selectedCategories.splice(index, 1);
        }
      }
    },

    isCheckAll(caseType, category) {
      let selectedCategory = this.panelsTestsData.selectedCategories.find(
        (selectedCategory) =>
          selectedCategory.case_type_code == caseType &&
          selectedCategory.panel_id == category
      );
      if (selectedCategory && selectedCategory.all_tests) {
        return true;
      }
      return false;
    },
    handleUrineCultureTests(selectedGroup) {
      if (this.checkConflictExist()) {
        this.selectedUrineCulturePanels.pop();
        return false;
      }

      if (selectedGroup.length) {
        let index = this.panelsTestsData.selectedGroup.findIndex((e) => e.case_type_code == selectedGroup[0].case_type_code)
        if (index > -1) {
          this.panelsTestsData.selectedGroup[index] = {
            group_id: selectedGroup[0]._id,
            panel_ids: selectedGroup[0].panel_ids.map((e) => e._id),
            case_type_code: selectedGroup[0].case_type_code,
          }
        } else {
          this.panelsTestsData.selectedGroup.push({
            group_id: selectedGroup[0]._id,
            panel_ids: selectedGroup[0].panel_ids.map((e) => e._id),
            case_type_code: selectedGroup[0].case_type_code,
          })
        }
      } else {
        let index = this.panelsTestsData.selectedGroup.findIndex((e) => e.case_type_code == "URINE_CULTURE")
        if (index > -1) {
          this.panelsTestsData.selectedGroup.splice(index, 1)
        }
      }
    },
    checkConflictExist() {
      let panel = this.selectedUrineCulturePanels.find((e) => {
        let otherPanels = this.selectedUrineCulturePanels
          .filter((f) => f.group_code != e.group_code)
          .map((f) => f.group_code);
        return this.arrayInterSection(otherPanels, e.exclude_groups).length > 0
          ? true
          : false;
      });
      if (panel) {
        this.$alert(
          "<strong>" +
          panel.exclude_groups.join(", ") +
          " and " +
          panel.group_code +
          " are not allowed to select at a time </strong>",
          "Warning",
          {
            dangerouslyUseHTMLString: true,
            type: "warning",
          }
        );
        return true;
      } else {
        return false;
      }
    },
    handleRemovedTests(testData) {
      let groupCode = testData.group_code;
      this.selectedUrineCulturePanels = this.selectedUrineCulturePanels.filter(
        (panel) => panel.group_code != groupCode
      );
    },
  },
  async mounted() {
    this.panelsTestsData = this.panelTestsData;
    this.loading = true;
    try {
      if (this.getNewLabGroupWiseTests && this.getNewLabGroupWiseTests.length) {
        this.urineCulturePanels = this.getNewLabGroupWiseTests.filter((e) => e.case_type_code == "URINE_CULTURE").filter(
          (panel) => panel.group_code
        );
        let selectedGroup = this.panelsTestsData.selectedGroup.filter((e) => e.case_type_code == "URINE_CULTURE")
        if (selectedGroup.length) {
          this.selectedUrineCulturePanels = this.urineCulturePanels.filter(
            (panel) => panel._id == selectedGroup?.[0].group_id
          )
        }
      }
      this.loading = false;
    } catch (err) {
      this.loading = false;
      console.log(err);
    }
  },
};
</script>
